import { Box } from '@mui/material';
import React from 'react';

export interface InfoCardHeaderProps {
  children: React.ReactNode;
}

/**
 * InfoCardHeader renders the standard three-column header grid for an info card.
 * @param props - Header children for avatar, main content, and optional actions.
 * @returns A grid header container.
 */
export const InfoCardHeader = ({ children }: InfoCardHeaderProps) => (
  <Box
    display="grid"
    fontSize="16px"
    gridTemplateColumns="48px 1fr auto"
    gap="12px"
    margin="16px"
  >
    {children}
  </Box>
);
